//replaces trend-line.html
import type { FC } from "react";

import { NgToReactChart } from "app/components/React/NgToReactChart/NgToReactChart";

interface ICellTrendLineTemplate {
    hasTrendLine: boolean;
    chatConfig: any;
}
export const TrendLineCellTemplateV2: FC<ICellTrendLineTemplate> = (props) => {
    const { hasTrendLine, chatConfig } = props;

    return (
        <>
            {hasTrendLine ? (
                <div id="trendLine">
                    <NgToReactChart highchartsNgConfig={chatConfig} />
                </div>
            ) : null}
            {!hasTrendLine ? (
                <div
                    id="trendLine"
                    className="u-gray-medium"
                >
                    N/A
                </div>
            ) : null}
        </>
    );
};
